// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"0d33805e","909":"99cb3d96"}[chunkId] + ".chunk.js";
};